import * as actionType from './ActionType';

export const setBlockRoute = (blockRoute) => ({
  type: actionType.SET_BLOCK_ROUTE,
  payload: {
    blockRoute
  }
});
